export const BASE = {
  rem: 16,
  radius: 4,
  padding: 4,
  // Font
  fontBold: 700,
  fontSemibold: 600,
  fontRegular: 500
};